import * as $ from "jquery";

export default class SignedupReady {
    constructor() {
        this.instance = this;
    }

    init() {
        let instance = this;

        $(document).ready(function () {
            if ($('.js-active-new-customer').length > 0) {
                instance.bind();
            }
        });
    }

    bind() {
        let instance = this;
        $('.js-active-new-customer').off().on('click', function () {
            let customerNumber = $(this).data('customernumber');
            let marketId = $(this).data('marketid');

            instance.activateNewCustomer(customerNumber, marketId);
        });
    }

    activateNewCustomer(customerNumber, marketId) {
        $.ajax({
            method: 'POST',
            url: '/customer/activatecustomer',
            data: { customerNumber: customerNumber, marketId: marketId },
            success: function (response) {
                window.location.href = '/order';
            },
            error: function (response) {
                console.log("ajax error:", response);
            }
        });
    }
}